import "slick-carousel/slick/slick.css";
import React from "react";
import Slider from "react-slick";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import ScrollTrigger from "gsap/ScrollTrigger";
import { useEffect, useRef } from "react";

import AOS from 'aos';
import 'aos/dist/aos.css';


const HomeWhatIs = () => {

   const settings = {
      slidesToShow: 3,
      infinite: true,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      variableWidth: true,
      arrows: false,
      adaptiveHeight: true,
      responsive: [{
         breakpoint: 1199,
         settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            variableWidth: false,
         }
      },
      {
         breakpoint: 991,
         settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            variableWidth: false,
         }
      },
      {
         breakpoint: 762,
         settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: false,
         }
      }

      ]
   };

   gsap.registerPlugin(useGSAP);
   gsap.registerPlugin(ScrollTrigger);

   useGSAP(() => {

      ScrollTrigger.matchMedia({
         "(min-width: 768px)": function () {

            let sections = gsap.utils.toArray(".element");

            gsap.to(sections, {
               xPercent: -100 * (sections.length - 2),
               ease: "none",
               scrollTrigger: {
                  trigger: ".CardTecAll",
                  pin: true,
                  scrub: 1,
                  snap: 1 / (sections.length - 2),
                  // base vertical scrolling on how wide the container is so it feels more natural.
                  start: "0% 30%",
                  //end: "+=4000 10%",
                  //invalidateOnRefresh: true,
                  //markers: true,
                  //pinnedContainer: ".hrScrlSecBg",
               }
            });
         }
      })

   }, {}); // <-- easily add a scope for selector text (optional)

   useEffect(() => {
      setInterval(() => {
         ScrollTrigger.refresh()
      }, [1500])


      AOS.init();
      AOS.refresh();
   }, [])




   return (
      <section className="IndSecThree">
         <div className="container-cusRight">
            <div className="TecNgsMns">
               <h2 data-aos='fade-left' data-aos-duration="1000">
                  <span className="TecNgsMnsTx1 noHl">Here What is</span> <span className="TecNgsMnsTx2">technology</span>  <span className="TecNgsMnsTx3 noHl">Means of you</span>
               </h2>
            </div>
            <div className="CardTecAll">

               <div className="CusSlkEle">
                  {/* <Slider {...settings} className="slick-slider"> */}
                  <div className="element element-1">
                     <div className="TecCardCmn">
                        <div className="df-ac ndgap-10 ndpb-21">
                           <div>
                              <img src={require("../../../assets/images/tcgic1.png")} alt="" />
                           </div>
                           <h2>Unmatched Security and Trust</h2>
                        </div>
                        <p>
                           Our smart contract has been upgraded and securely locked for 5 years, with a fully
                           verified,
                           open-source code. This ensures unparalleled transparency, integrity, and trust for
                           our
                           community, giving you the confidence that your investments are safeguarded by the
                           highest
                           standards of security.
                        </p>
                        <img className="lht" src={require("../../../assets/images/olliii.png")} alt="" />
                     </div>
                  </div>
                  <div className="element element-2">
                     <div className="TecCardCmn">
                        <div className="df-ac ndgap-10 ndpb-21">
                           <div>
                              <img src={require("../../../assets/images/tcgic2.png")} alt="" />
                           </div>
                           <h2>Scalability and Cost Efficiency</h2>
                        </div>
                        <p>
                           Polygon’s Layer 2 solution provides exceptional scalability and significantly
                           reduces
                           transaction fees compared to many other blockchains. This ensures a seamless and
                           cost-effective experience for all users, whether you’re staking, trading, or
                           engaging with
                           our ecosystem.
                        </p>
                        <img className="lht" src={require("../../../assets/images/olliii.png")} alt="" />
                     </div>
                  </div>
                  <div className="element element-3">
                     <div className="TecCardCmn">
                        <div className="df-ac ndgap-10 ndpb-21">
                           <div>
                              <img src={require("../../../assets/images/tcgic3.png")} alt="" />
                           </div>
                           <h2>Interoperability and Decentralization</h2>
                        </div>
                        <p>
                           Receive customized recommendations tailored to your goals, whether it’s improving ad
                           spend
                           efficiency, targeting high-value customers, or optimizing campaign timing. Predict
                           delivers
                           insights you can use right away to make smarter decisions.
                        </p>
                        <img className="lht" src={require("../../../assets/images/olliii.png")} alt="" />
                     </div>
                  </div>
                  <div className="element element-4">
                     <div className="TecCardCmn">
                        <div className="df-ac ndgap-10 ndpb-21">
                           <div>
                              <img src={require("../../../assets/images/tcgic4.png")} alt="" />
                           </div>
                           <h2>Smooth and Secure Migration</h2>
                        </div>
                        <p>
                           Polygon Chain has been meticulously executed to ensure a seamless transition for all
                           users.
                           Your assets and staking contracts have been securely transferred to the Polygon
                           Chain, and
                           you can now purchase and activate smart mining staking contracts on the new platform
                           with
                           ease.
                        </p>
                        <img className="lht" src={require("../../../assets/images/olliii.png")} alt="" />
                     </div>
                  </div>
                  <div className="element"></div>
                  {/* </Slider> */}
               </div>

            </div>
         </div>
      </section>
   )
}
export default HomeWhatIs;